
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentintelligence",
      function () {
        return require("private-next-pages/contentintelligence/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentintelligence"])
      });
    }
  